export default __webpack_public_path__ + "static/media/aws.620983df.svg";